import { GenIcon } from '../helpers/IconBase.es.js';

const VietnamColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M24 20C24 20.5525 23.5525 21 23 21H1C0.4475 21 0 20.5525 0 20V4C0 3.4475 0.4475 3 1 3H23C23.5525 3 24 3.4475 24 4V20Z",
          fill: "#F83142"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M16.1803 10.5205H13.2348L11.9998 7.84204L10.7633 10.5205H7.81885L9.97035 12.747L9.17535 15.9735L11.9998 14.369L14.8238 15.9735L14.0288 12.747L16.1803 10.5205Z",
          fill: "#FFE040"
        }
      }
    ]
  })(props);
};

export { VietnamColored };
